import script from "./dashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./dashboard.vue?vue&type=script&setup=true&lang=js"

import "./dashboard.vue?vue&type=style&index=0&id=d8ec6f70&lang=css"

const __exports__ = script;

export default __exports__